if (!customElements.get('led-mask-compare')) {
  customElements.define('led-mask-compare', class extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-lmc-scroller]');
      this.onScroll = () => this.scroller.toggleAttribute('data-scrolled', this.scroller.scrollLeft > 4);
      this.scroller?.addEventListener('scroll', this.onScroll, { passive: true });
      this.setupFreeze();

      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      // Never hide what is already on screen (first paint, theme editor reloads)
      if (reduce || !('IntersectionObserver' in window) || window.Shopify?.designMode || this.getBoundingClientRect().top < innerHeight * .9) {
        this.dataset.lmcState = 'in';
        return;
      }
      this.dataset.lmcState = 'pending';
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.play();
        this.observer.disconnect();
      }, { threshold: .12 });
      this.observer.observe(this);
    }

    // Phones: a copy of the product row pins under the site header while the table is on screen
    setupFreeze() {
      const head = this.querySelector('.lmc__table thead');
      if (!head || !this.scroller) return;
      this.freeze = document.createElement('div');
      this.freeze.className = 'lmc__freeze';
      this.freeze.setAttribute('aria-hidden', 'true');
      this.freeze.innerHTML = '<div class="lmc__freeze-bar"><table class="lmc__table"></table></div>';
      const bar = this.freeze.firstChild;
      const table = bar.firstChild;
      table.append(head.cloneNode(true));
      table.querySelectorAll('[id], [tabindex], a').forEach(el => { el.removeAttribute('id'); el.setAttribute('tabindex', '-1'); });
      this.scroller.before(this.freeze);

      const sync = () => {
        // Match the real column widths and the sideways scroll
        table.style.width = this.scroller.firstElementChild.offsetWidth + 'px';
        bar.scrollLeft = this.scroller.scrollLeft;
        const top = parseFloat(getComputedStyle(this.freeze).top) || 0;
        const headBox = head.getBoundingClientRect();
        const tableBox = this.scroller.getBoundingClientRect();
        this.freeze.classList.toggle('is-on', getComputedStyle(this.freeze).display !== 'none' && headBox.bottom < top && tableBox.bottom > top + 120);
      };
      this.onFreeze = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; sync(); }); };
      addEventListener('scroll', this.onFreeze, { passive: true });
      addEventListener('resize', this.onFreeze, { passive: true });
      this.scroller.addEventListener('scroll', this.onFreeze, { passive: true });
      sync();
    }

    play() {
      this.dataset.lmcState = 'in';
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.scroller?.removeEventListener('scroll', this.onScroll);
      removeEventListener('scroll', this.onFreeze);
      removeEventListener('resize', this.onFreeze);
    }
  });
}
